import {
  AdditionDeductionTransactionType,
  CashTransferStatus,
  PlayerBalanceAddition,
  PlayerBalanceAdditionFilterField,
} from '@/generated/graphql';

import { IPlayer, mapGQLPlayer } from './player';
import { ICashier, mapGQLCashier } from './cashier';
import { IPaymentGateway, mapGQLPaymentGateway } from './payment-gateway';
import { IAuditor, mapGQLAuditor } from './auditor';

export interface IPlayerBalanceAddition {
  id: string;
  amount: number;
  referenceId: string;
  transactionType: AdditionDeductionTransactionType;
  notes: string;
  status: CashTransferStatus;

  createdAt: string;
  updatedAt: string;

  player: IPlayer;
  cashier: ICashier;
  auditor: IAuditor;
  paymentGateway: IPaymentGateway;
}

export interface IPlayerBalanceAdditionQueryVariable {
  first: number;
  after?: string;
  before?: string;
  filterBy?: PlayerBalanceAdditionFilterField;
}

export interface IPlayerBalanceAdditionTable {
  id: string;
  amountDisplay: string;
  referenceId: string;
  createdAt: string;

  playerName: string;
  cashierName: string;
  cashierId: string;
  paymentGatewayNumber: string;
  notes: string;
  status: CashTransferStatus;
}

export interface IPlayerAdditionTransactionTable {
  id: string;
  amountDisplay: string;
  referenceId: string;
  createdAt: string;
  status: CashTransferStatus;
  transactionType: AdditionDeductionTransactionType;

  playerName: string;
  auditorName: string;
  paymentGatewayNumber: string;
}

export interface IAuditorPlayerAdditionTransactionTable {
  id: string;
  amountDisplay: string;
  referenceId: string;
  createdAt: string;
  status: CashTransferStatus;
  transactionType: AdditionDeductionTransactionType;

  playerName: string;
  cashierName: string;
  paymentGatewayNumber: string;
}

export interface IPlayerAdditionTransactionTable {
  id: string;
  amountDisplay: string;
  referenceId: string;
  createdAt: string;
  status: CashTransferStatus;
  transactionType: AdditionDeductionTransactionType;

  playerName: string;
  auditorName: string;
  paymentGatewayNumber: string;
}

export interface IPlayerAdditionTransactionTable_AD {
  id: string;
  amountDisplay: string;
  referenceId: string;
  createdAt: string;
  status: CashTransferStatus;
  transactionType: AdditionDeductionTransactionType;

  playerName: string;
  cashierName: string;
  auditorId: string;
  paymentGatewayNumber: string;
}

export function mapGQLPlayerBalanceAddition(gql_playerBalanceAddition?: PlayerBalanceAddition | null): IPlayerBalanceAddition {
  return {
    id: gql_playerBalanceAddition?.id ?? '',
    amount: gql_playerBalanceAddition?.amount ?? 0,
    referenceId: gql_playerBalanceAddition?.referenceId ?? '',
    transactionType: gql_playerBalanceAddition?.transactionType ?? AdditionDeductionTransactionType.Cash,
    notes: gql_playerBalanceAddition?.notes ?? '',
    status: gql_playerBalanceAddition?.status ?? CashTransferStatus.Pending,

    updatedAt: gql_playerBalanceAddition ? gql_playerBalanceAddition.updatedAt ?? new Date().toISOString() : new Date().toISOString(),
    createdAt: gql_playerBalanceAddition
      ? new Date(gql_playerBalanceAddition.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',

    player: mapGQLPlayer(gql_playerBalanceAddition?.player),
    cashier: mapGQLCashier(gql_playerBalanceAddition?.cashier),
    auditor: mapGQLAuditor(gql_playerBalanceAddition?.auditor),
    paymentGateway: mapGQLPaymentGateway(gql_playerBalanceAddition?.paymentGateway),
  };
}
